module.exports = __webpack_public_path__ + "static/media/xos-logo-rw.001bec57.png";